<template>
  <b-container fluid>
    <div>
      <b-navbar type="light" variant="light">
        <b-navbar-brand>
          <img src="/ops/img/eds_icon_32.png" alt="EDS" />
          <b> OPERATIONAL DASHBOARD </b></b-navbar-brand
        >
        <b-button-toolbar
          key-nav
          aria-label="Toolbar with button groups"
          v-if="dataLoaded"
        >
          <b-button-group class="mx-1">
            <!-- <b-button>&laquo;</b-button>-->
            <b-button
              type="button"
              class="btn btn-primary"
              @click="updateGraph(2)"
              >&lsaquo; Back (a)</b-button
            >
          </b-button-group>
          <b-button-group class="mx-1">
            <b-button @click="openTicket()">Create Ticket</b-button>
            <b-button
              @click="togglestreampaused"
              :variant="streamPausedVariant"
            >
              <span v-if="streampaused">Pause Stream (s)</span
              ><span v-if="!streampaused">Resume Stream (s)</span></b-button
            >
               
            <b-button @click="openPnp()" >View on PnP Scada</b-button>
          </b-button-group>
          <b-button-group class="mx-1">
            <b-button
              type="button"
              class="btn btn-primary"
              @click="updateGraph(1)"
              >&rsaquo; Forward (d)</b-button
            >
            <!--<b-button>&raquo;</b-button>-->
          </b-button-group>

        </b-button-toolbar>
        <div v-if="dataLoaded"><b-form-select v-model="cycleSpeed" @change="cycleSpeedChange">
              <option selected value="1">Cycle 7s </option>
              <option selected value="2">Cycle 12s </option>
              <option selected value="3">Cycle 25s </option>
              <option selected value="4">Cycle 45s </option>
                </b-form-select>
                </div>
        <div>
          <small> {{ status }} </small>
        </div>

        <b-nav-form v-if="dataLoaded">
          <b-form-select
            style="overflow:scroll;"
            v-model="currentIndex"
            @change="changeSelection()"
          >
            <option
              v-for="(item, index) in meterAccountList"
              v-bind:key="item.idMeterAccount"
              :value="item.index"
              >{{ item.name }} - {{ item.idMeterAccount }}</option
            >
          </b-form-select>
          <!--<b-form-input class="mr-sm-2" placeholder="Search"></b-form-input>
            <b-button variant="outline-success" class="my-2 my-sm-0" type="submit">Search</b-button>-->
        </b-nav-form>
      </b-navbar>
    </div>
    <div>
      <b-row v-if="!dataLoaded">
        <b-col>
          <img src="/ops/img/ajax-loader.gif" />
        </b-col>
      </b-row>
      <b-row v-if="dataLoaded && !hideAllAccountInfo">
        <b-col :height="window.height - 20">
          <!-- <b-card   title="AMS001 - Arcelormittal Newcastle B.O.F Off Gas ID Fans VSD 2 ; Sch02-Sys2 (1085.488kW) [21117567]"> -->
          <b-progress 
            :value="meterAccountList[currentIndex].index + 1"
            :max="meterAccountList.length + 1"
            show-progress
            animated
          ></b-progress>
          <div v-if="activeSavings.last7days">
          <h4 v-bind:style="{ background: headerColor }" style="color:white">
            {{ ActiveMeterAccountName }} 
          </h4>
          </div>
          <h5>Last 24 Hours</h5>

          <div  v-on:dblclick="resetGraphZoom()">
            <apexchart
              ref="topChart"
              :key="graphRerenderKeyTop"
              type="bar"
              :height="window.height * 0.4"
              :width="(window.width - offset) / 2 - 50"
              :options="options1"
              :series="ActiveSeries2"
             
            />
          </div>
          <div>
            <b>Tags : <span v-if="meterAccountTags.length < 1">None</span></b
            ><b-badge
              style="height: 30px; font-size: 16px;"
              class="align-middle"
              v-for="item in meterAccountTags"
              v-tooltip="item.Description"
              v-bind:key="item.idMATag"
              pill
              variant="primary" v-b-modal.modal-2
              @click="setCurrentTagClicked(item)"
              >{{ item.TagName }}</b-badge>

            <b-modal id="modal-2" title="Remove a Tag : " @ok="removeTag(clickedTag)">
              <p class="my-4">Remove this Tag ?</p>
              <div v-if="clickedTag != null" > Tag name : {{clickedTag.TagName}} 
                Tag Description <br> {{clickedTag.TagDescription}} 
              </div>
              
           </b-modal>

            <b-button pill variant="outline-secondary" v-b-modal.modal-1>Attach Tag ...</b-button>
            <b-modal id="modal-1" title="Attach a Tag"  @ok="addTag" v-model="modalStateTag">
              <p class="my-4">Select Tag Category</p>
              
              <b-form-select v-model="selectedTagCategory" @change="tagCatChange">
              <option disabled value="-1">Please select Category</option>
              <option v-for="option in tagCategories" v-bind:value="option.idTagCategory" >{{option.TagCategoryName}}</option>
              </b-form-select>
              <div v-if="selectedTagCategory != -1">
              <p class="my-4">Select Tag</p>
              
                <b-form-select v-model="selectedTagType">
                <option disabled value="-1">Please select tag</option>
                <option v-for="option in listTags" v-bind:value="option.idTag" >{{option.TagName}} - {{option.TagCode}}</option>
                </b-form-select>
                <div v-if="selectedTagType!=-1&&selectedTagCategory!=-1">
                  <br>
                <b-form-input  v-model="tagDescription" placeholder="Add Description"></b-form-input>
                </div>
              </div>
           </b-modal>
          </div>
          <br />

          <h5>Last 30 Days</h5>
          <div v-on:dblclick="resetGraphZoom()">
            <apexchart
              ref="bottomChart"
              :key="graphRerenderKeyBot"
              type="bar"
              :height="window.height * 0.25"
              :width="(window.width - offset) / 2 - 50"
              :options="options2"
              :series="ActiveSeries"
            />
          </div>
          <!--<apexchart type=bar height=350 :width="window.width-offset" :options="options1" :ActiveSeries="ActiveSeries" />-->
          <div>
            <b
              >Tickets :
              <span v-if="meterAccountTickets.length < 1">None</span></b
            ><b-badge
              style="height: 30px; font-size: 16px;"
              class="align-middle"
              v-for="item in meterAccountTickets"
              v-tooltip="item.TicketIssued + '\n' + item.Description"
              v-bind:key="item.idTicket"
              pill
              :variant="item.variant"
              @click="pillclicked(item.idTicket)"
              >{{ item.TagPrefix }}{{ item.idTicket }}</b-badge>
              <component-createticket buttontext="Bypass" :p_idSite="meterAccountList[currentIndex].idSite" :p_idMeterAccount="meterAccountList[currentIndex].idMeterAccount"></component-createticket>
          </div>
          <br />
        </b-col>
        <b-col>
          <div v-if="dataLoaded && !hideAllAccountInfo">
            <b-card no-body>
              <b-tabs card>
                <b-tab title="Processed Consumption Data" active>
                  <b-card v-if="processedConsumptionAvailable">
                   <div>
                    <apexchart
                      ref="pcChart"
                      :key="graphRerenderKeyPC"
                      type="line"
                      :height="window.height * 0.4"
                      :width="(window.width - offset) / 2 - 100"
                      :options="processedGraphOptions"
                      :series="activeProcessedConsumption"
                    />
                  </div>
                  <div>
                    <apexchart
                      ref="pcChart"
                      :key="graphRerenderKeyPC"
                      type="bar"
                      :height="window.height * 0.4"
                      :width="(window.width - offset) / 2 - 100"
                      :options="processedStackGraphOptions"
                      :series="activeProcessedConsumptionStack"
                    />
                  </div> 
                  </b-card>
                  <b-card v-if="!processedConsumptionAvailable">
                    <h2> No processed consumption are available for this meter</h2>
                  </b-card>
                  
                </b-tab>
                <b-tab title="Savings Data" active>
                  <b-card v-if="savingsAvailable">
                    <apexchart
                      ref="pcChart"
                      :key="graphRerenderKeyPC"
                      type="bar"
                      :height="window.height * 0.4"
                      :width="(window.width - offset) / 2 - 100"
                      :options="savingGraphOptions"
                      :series="savingsgraphData"
                    />
                  </b-card>
                  <div v-if="!savingsAvailable">
                    No savings data are available.
                  </div>
                </b-tab>
                <b-tab title="Tickets">
                  <div
                    style="overflow:auto;"
                    v-bind:style="{ height: window.height - 200 + 'px' }"
                  >
                    <div
                      v-for="ticket in meterAccountTickets"
                      v-bind:key="ticket.idTicket"
                      style="text-align: left"
                      auto
                    >
                      <b-card v-bind:title="'Ticket #' + ticket.idTicket">
                        <b>Ticket Issued : </b> {{ ticket.TicketIssued }}
                        <br />
                        <b> Ticket Description </b><br />
                         {{ ticket.Description }}<br/>
                        <div v-if="ticket.Resolved">
                          <b>Resolved Comment</b><br>
                          {{ticket.ResolvedComment}}<br>
                          <b>Resolved date : </b>{{ticket.ResolvedDate}}

                        
                        </div>
                        <br/>
                        <a
                          v-bind:href="
                            'https://energydrive.dnsalias.com/ticketcop/viewTicket/' +
                              ticket.idTicket
                          "
                          target="_blank"
                          class="badge badge-success"
                          >Click to open Ticket in Ticketcop</a
                        ><br />
                      </b-card>
                    </div>
                  </div>
                  <br />
                </b-tab>
                <b-tab title="PLC Data" active>
                  <div
                    style="overflow:auto;"
                    v-bind:style="{ height: window.height - 200 + 'px' }"
                  >
                    <b-card v-if="!showPLCDetails">Loading ...</b-card>
                    <b-card v-if="showPLCDetails">
                      <div
                        v-if="noPLCLinked"
                        style="background:orange;color:white"
                      >
                        There are no PLC Ids linked to this meter account.
                      </div>
                      <div v-if="!noPLCLinked">
                        <div
                          v-for="par in listPLC"
                          v-bind:key="par.idParameter"
                          v-on:dblclick="resetGraphZoom()"
                        >
                          <h4>{{ par.ParDesc }}</h4>
                          <div v-if="par.showgraph" >
                            <apexchart
                              :ref="par.ParDesc"
                              :key="par.rerenderkey"
                              type="line"
                              :height="
                                ((window.height - 200) / listPLC.length) * 0.75
                              "
                              :width="(window.width - offset) / 2 - 100"
                              :options="optionsPLC"
                              :series="par.data"
                            />
                          </div>
                          <div v-if="!par.showgraph">
                            Loading data ....
                          </div>
                        </div>
                      </div>
                    </b-card>
                  </div>
                </b-tab>
                <!--<b-tab title="Telegram Chat Log (Beta)">
                            <b-card>NOT AVAILABLE</b-card>
                        </b-tab>-->
              </b-tabs>
            </b-card>
          </div>
        </b-col>

        <!-- </b-card>-->
      </b-row>

      <!--<b-row>
            <div v-if="dataLoaded&&!hideAllAccountInfo" style="text-align:center">
                <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                    <b-button-group class="mx-1">
                  
                    <b-button type="button" class="btn btn-primary" @click="updateGraph(2)">&lsaquo;</b-button>
                    </b-button-group>
                    <b-button-group class="mx-1">
                    <b-button>Create Ticket</b-button>
                    <b-button @click="streampaused = !streampaused"> <span v-if="streampaused">Pause Stream</span><span v-if="!streampaused">Resume Stream</span></b-button>
                    <b-button>View on PnP Scada</b-button>
                    </b-button-group>
                    <b-button-group class="mx-1">
                    <b-button type="button" class="btn btn-primary" @click="updateGraph(1)">&rsaquo;</b-button>
                  
                    </b-button-group>
                </b-button-toolbar>
            </div>
        </b-row>-->
    </div>
    <!-- Top level div -->
  </b-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import createTicket from "../components/CreateTicket.vue";

var CYCLE_TIMER;
var ALLOW_KEY_STROKES = true;

export default {
  name: "viewSite",
  props: ["idMeterAccount"],
  components: {
    "component-createticket": createTicket
  },
  data: () => ({
    currentIndex: 0,
    dataLoaded: false,
    status: "",
    hideAllAccountInfo: false,
    window: {
      width: 0,
      height: 0
    },
    offset: 50,
    graphRerenderKeyTop: 0,
    graphRerenderKeyBot: 0,
    graphRerenderKeyPLC: 0,
    timeElapsed: 0,
    options1: {
      annotations: {
        yaxis: [
          {
            y: 90,
            borderColor: "#fc0303",
            label: {
              borderColor: "#000000",
              style: {
                color: "#fff",
                background: "#fc0303",
                fontSize: "16px"
              },
              text: ""
            }
          }
        ],
        points: [
          {
            x: new Date("7 Nov 2019").getTime(),
            y: 38.5,
            marker: {
              size: 6,
              fillColor: "#fff",
              strokeColor: "#2698FF",
              radius: 2
            },
            label: {
              borderColor: "#FF4560",
              offsetY: 0,
              style: {
                color: "#fff",
                background: "#FF4560",
                fontSize: "12px"
              },

              text: ""
            }
          }
        ]
      },
      chart: {
        id: "vuechart-example",
        //  group: 'BacktestCharts',  // uncomment to sync graphs
        animations: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      //colors: ['#00456b', '#578e67', '#d9815b', '#fec054', '#4a4a4a', '#3455cd', '#5cd8f1', '#8f1789', '#c35989', '#78945d'],
      colors: [
        function({ value, seriesIndex, w }) {
          if (value < 55) {
            return "#7E36AF";
          } else {
            return "#D9534F";
          }
        },
        function({ value, seriesIndex, w }) {
          if (value < 100) {
            return "#7E36AF";
          } else {
            return "#D9534F";
          }
        }
      ],

      zoom: {
        type: "x",
        enabled: true,
        autoScaleYaxis: true
      },
      xaxis: {
        type: "datetime",
        labels: {
          show: true,
          formatter: function(value, timestamp, index) {
            return moment(new Date(timestamp)).format("YYYY-MM-DD hh:mm");
          }
        }
      },
      yaxis: {
        max: 100
      }
    },
    options2: {
      annotations: {
        yaxis: [
          {
            y: 90,
            borderColor: "#fc0303",
            label: {
              borderColor: "#000000",
              style: {
                color: "#fff",
                background: "#fc0303",
                fontSize: "16px"
              },
              text: "KiloWatt Baseline"
            }
          }
        ]
      },
      chart: {
        id: "vuechart-example2",
        //  group: 'BacktestCharts',  // uncomment to sync graphs
        animations: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      colors: ["#00456b"],

      zoom: {
        type: "x",
        enabled: true,
        autoScaleYaxis: true
      },
      xaxis: {
        type: "datetime",
        labels: {
          show: true,
          formatter: function(value, timestamp, index) {
            return moment(new Date(timestamp)).format("YYYY-MM-DD hh:mm");
          }
        }
      },
      yaxis: {
        max: 100
      }
    },
    options3: {
      chart: {
        id: "vuechart-example2",
        group: "BacktestCharts",
        animations: {
          enabled: false
        }
      },
      colors: ["#00456b"],
      zoom: {
        type: "x",
        enabled: true,
        autoScaleYaxis: true
      },
      xaxis: {
        type: "datetime",
        labels: {
          show: true,
          formatter: function(value, timestamp, index) {
            return moment(new Date(timestamp)).format("YYYY-MM-DD hh:mm:ss");
          }
        }
      }
    },
    optionsPLC: {
      chart: {
        id: "vuechart-example2",
        //  group: 'BacktestCharts',  // uncomment to sync graphs
        animations: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      //colors: ['#00456b', '#578e67', '#d9815b', '#fec054', '#4a4a4a', '#3455cd', '#5cd8f1', '#8f1789', '#c35989', '#78945d'],
      colors: ["#009933"],
      stroke: {
        width: 1
      },
      zoom: {
        type: "x",
        enabled: true,
        autoScaleYaxis: true
      },
      xaxis: {
        type: "datetime",
        labels: {
          show: true,
          formatter: function(value, timestamp, index) {
            return moment(new Date(timestamp)).format("YYYY-MM-DD hh:mm");
          }
        }
      },
      yaxis: {
        max: 55,
        min: 0
      }
    },
    ActiveMeterAccountName: "",
    BypassThreshold: 0,
    headerColor: "#009933",
    ActiveSeries: [],
    ActiveSeries2: [],
    meterAccountList: [],
    todaysDate: null,
    selectedTagType: -1,
    selectedTagCategory: -1,
    modalStateTag: null,
    tagCategories: [],
    tagType: [],
    tagDescription: "",
    clickedTag: null,

    cycleSpeed: 1,
    streampaused: false,
    streamPausedVariant: "warning",
    rawConsumptionData: [],
    ActiveBaseline: 0,
    activeSavings: [],
    savingsAvailable: false,
    allTickets: [],
    allTags: [],
    // parameters for processed consumption
    processedConsumptionAvailable: false,
    processedConsumptionData: [],
    processedComsumptionLoaded: false,
    processedGraphOptions: null,
    activeProcessedConsumption: [],
    processedStackGraphOptions: null,
    activeProcessedConsumptionStack: [],
    savingGraphOptions: null,
    savingsgraphData: [],
    graphRerenderKeyPC: 0,
    // parameters used to display PLC data
    showPLCDetails: false,
    listPLC: [],
    noPLCLinked: false,
    backendUrl: "https://energydrive.dnsalias.com/opsdashapi"
    //backendUrl: "http://localhost:3000"
  }),
  /*watch: {
    // whenever question changes, this function will run
    selectedidMeterAccount: function(newQuestion, oldQuestion) {
      
    }
  },*/
  methods: {
    allowKeys: function(state) {
      ALLOW_KEY_STROKES = state;
    },
    cycleSpeedChange: function() {
      console.log("Set new interval");
      this.$nextTick(function() {
        let self = this;
        let newInterval = 7000;
        switch (self.cycleSpeed) {
          case "1":
            newInterval = 7000;
            break;
          case "2":
            newInterval = 12000;
            break;
          case "3":
            newInterval = 25000;
            break;
          case "4":
            newInterval = 45000;
            break;
        }
        console.log(newInterval);
        clearInterval(CYCLE_TIMER);
        CYCLE_TIMER = setInterval(function() {
          if (self.streampaused) {
            self.updateGraph(1);
            self.renderPCGraph();
          }
        }, newInterval);
      });
    },
    setCurrentTagClicked: function(tag) {
      this.clickedTag = tag;
      console.log("Clicked on");
      console.log(this.clickedTag);
    },
    removeTag: function(tag) {
      console.log("Remove Tag");
      console.log(tag);
    },
    tagCatChange: function() {
      this.selectedTagType = -1;
      console.log("Cganged tag cat");
    },
    changeSelection: function() {
      ALLOW_KEY_STROKES = false;
      this.$nextTick(function() {
        this.hideAllAccountInfo = true;
        console.log("Changed selection");
        console.log(this.currentIndex);
        this.updateGraph(3);
        this.renderPCGraph();
      });
    },

    resetGraphZoom: function() {
      try {
        let self = this;

        self.$refs.bottomChart.resetSeries();
        for (let i = 0; i < self.listPLC.length; i++) {
          let txt = "" + self.listPLC[i].ParDesc;

          self.$refs[txt][0].resetSeries();
          self.listPLC[i].rerenderkey += 1;
        }
        self.graphRerenderKeyTop++;
        self.graphRerenderKeyBot++;
        self.graphRerenderKeyPLC++;
      } catch (err) {}
    },

    togglestreampaused: function() {
      let self = this;
      self.streampaused = !self.streampaused;
      if (!self.streampaused) {
        self.streamPausedVariant = "warning";
      } else self.streamPausedVariant = "success";
    },
    // cycles through the list meterAccountList
    updateGraph: function(state) {
      ALLOW_KEY_STROKES == false;
      this.$nextTick(function() {
        let self = this;
        self.hideAllAccountInfo = true;
        self.activeSavings = null;

        switch (state) {
          case 1: // cycle forward
            if (self.currentIndex < self.meterAccountList.length - 1) {
              console.log("Add 1 to currentindex : " + self.currentIndex);
              self.currentIndex = self.currentIndex + 1;
              /*if ( self.currentIndex > (self.meterAccountList.length - 1))
                        {
                           
                            self.currentIndex = 0;
                             console.log("Set currentindex to 0 : "+self.currentIndex)
                        } */
            } else {
              self.currentIndex = 0;
              console.log("Set currentindex to 0 : " + self.currentIndex);
            }
            break;
          case 2: // cycle backwards
            if (self.currentIndex > 0) {
              console.log(
                "subtract 1 from currentindex : " + self.currentIndex
              );
              self.currentIndex = self.currentIndex - 1;
              /*if ( self.currentIndex < 0 ) 
                        {
                            self.currentIndex = self.meterAccountList.length - 1;
                            console.log("Set currentindex to self.meterAccountList.length - 1 : "+self.currentIndex)
                        }*/
            } else {
              self.currentIndex = self.meterAccountList.length - 1;
              console.log(
                "Set currentindex to self.meterAccountList.length - 1 : " +
                  self.currentIndex
              );
            }
            break;
          case 3: // selection changed
            //console.log("Hit case 3 so do nothing")
            break;
          default:
            console.log("hit default case");
            break;
        }

        console.log("self.currentIndex : " + self.currentIndex);
        ALLOW_KEY_STROKES == true;
        self.renderGraph();
      });
    },

    renderGraph: function() {
      console.log("Calling rendergraph");
      let self = this;
      self.hideAllAccountInfo = true;
      self.ActiveMeterAccountName =
        self.meterAccountList[self.currentIndex].name;
      self.BypassThreshold =
        self.meterAccountList[self.currentIndex].BypassThreshold;
      if (isNaN(self.BypassThreshold)) self.BypassThreshold = 0;
      //TEST MEMORy mangement
      try {
        //console.log("Clearing memory ..");
        //self.$refs.topChart.destroy();
        //self.$refs.bottomChart.destroy();
        self.ActiveSeries2.data = [];
        self.ActiveSeries.data = [];
        for (let i = 0; i < self.listPLC.length; i++) {
          let txt = "" + self.listPLC[i].ParDesc;
          //console.log( self.$refs[txt][0]);
          self.listPLC[i].data = [];
          //self.$refs[txt][0].destroy();
        }
      } catch (err) {
        //console.log(err);
      }

      // END TEST

      console.log(
        "currentIndex in selcetdidmeterAccount: " + self.currentIndex
      );

      let data = [];

      data = self.rawConsumptionData.filter(function(item) {
        if (
          item.idMeterAccount ==
          self.meterAccountList[self.currentIndex].idMeterAccount
        ) {
          return true;
        } else {
          return false;
        }
      });
      let tmpData = null;
      tmpData = [];
      for (let i = 0; i < data.length; i++) {
        data[i].newTime = parseInt(moment(data[i].DateTime).format("x"));
        tmpData.push([data[i].newTime, data[i].ImportkW]);
      }

      let base = self.ActiveMeterAccountName.match(/\(.*kW\)/i) + "";
      base = base
        .replace("(", "")
        .replace(")", "")
        .replace("kW", "");

      self.ActiveBaseline = parseFloat(base);
      //if ( true ) // test if this is better
      if (isNaN(self.ActiveBaseline)) {
        // old way
        self.ActiveBaseline = 0;
        // no active baselien defined so find max value
        let max = 0;
        for (let i = 0; i < tmpData.length; i++) {
          if (tmpData[i][1] > max) max = tmpData[i][1];
        }
        self.ActiveBaseline = max * 1.05;
        self.options1.yaxis.max = self.ActiveBaseline * 1.1;
        //self.options1.xaxis.max = parseInt(moment().hour(12).minute(0).second(0).format("x"));
        self.options1.annotations.yaxis[0].label.text =
          "Baseline Not defined in name";
        //self.options1.colors = ["#00456b"];
        self.options1.colors = [
          function({ value, seriesIndex, w }) {
            //  if (value < 50 ) {
            for (let i = 0; i < self.meterAccountTags.length; i++) {
              if (
                self.meterAccountTags[i].TagCategory == 10 ||
                self.meterAccountTags[i].TagCategory == 2 ||
                self.meterAccountTags[i].TagCategory == 9
              ) {
                return "#404040";
              }
            }
            if (value < self.BypassThreshold) {
              return "#ff9900";
            } else {
              return "#00456b";
            }
          }
        ];

        self.options2.yaxis.max = self.ActiveBaseline * 1.1;
        //self.options2.xaxis.max = parseInt(moment().format("x"));
        self.options2.annotations.yaxis[0].label.text =
          "Baseline Not defined in name";
        //self.options2.colors = ["#00456b"];
        self.options2.colors = [
          function({ value, seriesIndex, w }) {
            //if (value < 50 ) {
            for (let i = 0; i < self.meterAccountTags.length; i++) {
              if (
                self.meterAccountTags[i].TagCategory == 10 ||
                self.meterAccountTags[i].TagCategory == 2 ||
                self.meterAccountTags[i].TagCategory == 9
              ) {
                return "#404040";
              }
            }
            if (value < self.BypassThreshold) {
              return "#ff9900";
            } else {
              return "#00456b";
            }
          }
        ];
        self.headerColor = "#ff9900";
      } else {
        self.options1.yaxis.max = parseInt(
          Math.round(self.ActiveBaseline * 1.2)
        );
        self.options1.annotations.yaxis[0].y = self.ActiveBaseline;
        self.options1.annotations.yaxis[0].label.text =
          "Baseline : " + self.ActiveBaseline + " kW";
        //self.options1.colors = ["#00456b"];
        self.options1.colors = [
          function({ value, seriesIndex, w }) {
            //if (value < 50 ) {
            for (let i = 0; i < self.meterAccountTags.length; i++) {
              if (
                self.meterAccountTags[i].TagCategory == 10 ||
                self.meterAccountTags[i].TagCategory == 2 ||
                self.meterAccountTags[i].TagCategory == 9
              ) {
                return "#404040";
              }
            }
            if (value < self.BypassThreshold) {
              return "#ff9900";
            } else {
              return "#00456b";
            }
          }
        ];
        self.options2.yaxis.max = parseInt(
          Math.round(self.ActiveBaseline * 1.2)
        );
        self.options2.annotations.yaxis[0].y = self.ActiveBaseline;
        self.options2.annotations.yaxis[0].label.text =
          "Baseline : " + self.ActiveBaseline + " kW";
        //self.options2.colors = ["#00456b"];
        self.options2.colors = [
          function({ value, seriesIndex, w }) {
            //if (value < 50 ) {

            for (let i = 0; i < self.meterAccountTags.length; i++) {
              if (
                self.meterAccountTags[i].TagCategory == 10 ||
                self.meterAccountTags[i].TagCategory == 2 ||
                self.meterAccountTags[i].TagCategory == 9
              ) {
                return "#404040";
              }
            }
            if (value < self.BypassThreshold) {
              return "#ff9900";
            } else {
              return "#00456b";
            }
          }
        ];

        self.headerColor = "#009933";
      }

      try {
        self.ActiveSeries2.data = [];
        self.ActiveSeries.data = [];
      } catch (err) {}
      self.ActiveSeries = null;
      self.ActiveSeries = [];
      self.ActiveSeries = [
        {
          name: self.ActiveMeterAccountName,
          data: tmpData
        }
      ];
      self.ActiveSeries2 = null;
      self.ActiveSeries2 = [];
      self.ActiveSeries2 = [
        {
          name: self.ActiveMeterAccountName,
          data: tmpData.slice(tmpData.length - 48 * 3)
        }
      ];
      ALLOW_KEY_STROKES = true;
      self.getSavingMeterAccount(
        self.meterAccountList[self.currentIndex].idMeterAccount,
        function() {
          self.graphRerenderKeyTop += 1;
          self.graphRerenderKeyBot += 1;

          self.getPLCData();
          self.hideAllAccountInfo = false;
        }
      );
      self.getSavingMeterAccountPercentage(
        self.meterAccountList[self.currentIndex].idMeterAccount,
        function() {
          /*self.graphRerenderKeyTop += 1;
          self.graphRerenderKeyBot += 1;

          self.getPLCData();
          self.hideAllAccountInfo = false;*/
        }
      );
    },

    renderPCGraph: function() {
      console.log("Calling render process consumption graph");
      let self = this;
      if (self.processedComsumptionLoaded) {
        //TEST MEMORy mangement
        try {
          self.activeProcessedConsumption.data = [];
          self.activeProcessedConsumptionStack.data = [];
        } catch (err) {
          console.log(err);
        }

        let data = [];

        data = self.processedConsumptionData.filter(function(item) {
          if (
            item.idMeterAccount ==
            self.processedConsumptionData[self.currentIndex].idMeterAccount
          ) {
            return true;
          } else {
            return false;
          }
        });
        if (data.length > 0) self.processedConsumptionAvailable = true;
        let tmpData = null;
        tmpData = [];
        let tmpData2 = null;
        tmpData2 = [];
        let tmpData3 = null;
        tmpData3 = [];
        let tmpData4 = null;
        tmpData4 = [];
        for (let i = 0; i < data.length; i++) {
          data[i].newTime = parseInt(moment(data[i].DateTime).format("x"));
          tmpData.push([
            data[i].newTime,
            Math.round(data[i].ManualAdjustedkWh)
          ]);
          tmpData2.push([
            data[i].newTime,
            Math.round(data[i].ClientAdjustedkWh)
          ]);
          tmpData3.push([data[i].newTime, Math.round(data[i].ImportkWh)]);
          tmpData4.push([
            data[i].newTime,
            Math.round(data[i].PreEDSRunningkWh)
          ]);
        }

        self.activeProcessedConsumption = [
          {
            name: "ImportkWh",
            type: "column",

            data: tmpData3
          },
          {
            name: "kWBaseline",
            type: "line",

            data: tmpData4
          }
        ];

        self.activeProcessedConsumptionStack = [
          {
            name: "ManualAdjustedkWh",
            type: "column",

            data: tmpData
          },
          {
            name: "ClientAdjustedkWh",
            type: "column",

            data: tmpData2
          },
          {
            name: "ImportkWh",
            type: "column",

            data: tmpData3
          }
        ];
      }
    },
    // opens a new ticket in ticketcop
    pillclicked: function(idTicket) {
      let link =
        "https://energydrive.dnsalias.com/ticketcop/viewTicket/" + idTicket;
      window.open(link);
    },
    addKeyboardEvents: function() {
      let self = this;
      document.addEventListener("keyup", function(event) {
        if (event.defaultPrevented) {
          return;
        }
        self.$nextTick(function() {
          var key = event.key || event.keyCode;

          if (self.dataLoaded == true) {
            if (ALLOW_KEY_STROKES == true && self.modalStateTag != true) {
              if (key === "d") {
                console.log("Pressed d");
                self.updateGraph(1);
                self.renderPCGraph();
              }
              if (key === "a") {
                console.log("Pressed a");
                self.updateGraph(2);
                self.renderPCGraph();
              }
            }
          }
          if (self.modalStateTag != true) {
            /*if (key === "s" || key === 83 || key === "S") {
              self.streampaused = !self.streampaused;
              if (!self.streampaused) {
                self.streamPausedVariant = "warning";
              } else self.streamPausedVariant = "success";
            }*/
          }
        });
      });
    },
    addTag: function() {
      let self = this;
      console.log("Calling add tag");
      if (self.selectedTagType != -1) {
        axios
          .get(self.backendUrl + "/addTag", {
            params: {
              idMeterAccount:
                self.meterAccountList[self.currentIndex].idMeterAccount,
              idTag: self.selectedTagType,
              createdBy: "Andre Lochner",
              description: self.tagDescription
            }
          })
          .then(function(response) {
            console.log(response);
            self.getAllTags(function(err) {
              console.log("Got all the tags");
            });
            // needs to call getOverviewParameters
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    removeTag: function(clickedTag) {
      let self = this;
      console.log("Calling remove tag");

      axios
        .get(self.backendUrl + "/removeTags", {
          params: {
            idMATag: clickedTag.idMATag
          }
        })
        .then(function(response) {
          console.log(response);
          self.getAllTags(function(err) {
            console.log("Got all the tags");
          });
        })
        // needs to call getOverviewParameters

        .catch(function(error) {
          console.log(error);
        });
    },

    // get PLC data for idPLC linked to meter account
    getPLCData: function() {
      let self = this;
      self.showPLCDetails = false;
      self.noPLCLinked = false;
      self.listPLC = [];

      axios
        .get(self.backendUrl + "/getPLCDataforMeteraccount", {
          params: {
            idMeterAccount:
              self.meterAccountList[self.currentIndex].idMeterAccount,
            startDate: self.todaysDate
          }
        })
        .then(function(response) {
          try {
            if (response.data[0].idPLCDetail != null) {
              // there is a plc linked to this meter account
              self.noPLCLinked = false;

              self.getOverviewParameters(response.data[0].idPLCDetail, function(
                err,
                data
              ) {
                self.listPLC = data;
                let plcDate = moment()
                  .subtract(1, "day")
                  .format("YYYY-MM-DD hh:mm");
                for (let i = 0; i < self.listPLC.length; i++) {
                  self.listPLC[i].showgraph = false;
                  axios
                    .get(self.backendUrl + "/getPLCData", {
                      params: {
                        idParameter: self.listPLC[i].idParameter,
                        date: plcDate
                      }
                    })
                    .then(function(response) {
                      let tmpData = null;
                      tmpData = [];
                      for (let i = 0; i < response.data.length; i++) {
                        response.data[i].newTime = parseInt(
                          moment(response.data[i].Date).format("x")
                        );
                        tmpData.push([
                          response.data[i].newTime,
                          response.data[i].SV
                        ]);
                      }
                      self.listPLC[i].data = [
                        {
                          name:
                            self.listPLC[i].ParDesc +
                            " - " +
                            self.listPLC[i].Parname,
                          data: tmpData
                        }
                      ];
                      self.optionsPLC.color = ["#009933"];
                      self.optionsPLC.xaxis.max = parseInt(
                        moment().format("x")
                      );
                      self.listPLC[i].rerenderkey = 1;
                      self.listPLC[i].rerenderkey += 1;
                      self.listPLC[i].showgraph = true;
                      self.showPLCDetails = false;
                      self.showPLCDetails = true;
                    })
                    .catch(function(error) {
                      console.log("Error Getting getPLCData  data");
                      console.log(error);
                      self.noPLCLinked = true;
                      self.showPLCDetails = true;
                    });
                }
              });
            } else {
              //console.log("No PLC id for this");
              self.noPLCLinked = true;
              self.showPLCDetails = true;
            }
          } catch (err) {
            self.noPLCLinked = true;
            self.showPLCDetails = true;
          }
          // needs to call getOverviewParameters
        })
        .catch(function(error) {
          console.log("Error Getting getPLCData data");
          console.log(error);
        });
    },

    getidPLC: function() {
      let self = this;
      axios
        .get(self.backendUrl + "/getPLCDataforMeteraccount", {
          params: {
            idMeterAccount:
              self.meterAccountList[self.currentIndex].idMeterAccount,
            startDate: self.todaysDate
          }
        })
        .then(function(response) {
          try {
            // console.log(response.data[0]);
            if (response.data[0].idPLCDetail != null) {
              self.activePLCid = response.data[0].idPLCDetail;
            } else {
              self.activePLCid = -1;
            }
          } catch (err) {
            console.log(err);
          }
        });
    },
    getMeterAccounts(callback) {
      let self = this;
      let start = moment();
      self.status = "Loading meter accounts ...";
      axios
        .get(self.backendUrl + "/getMeterAccounts", {})
        .then(function(response) {
          let tmp = [];
          for (let i = 0; i < response.data.length; i++) {
            tmp.push({
              index: i,
              name: response.data[i].MeterAccountName,
              idMeterAccount: response.data[i].idMeterAccount,
              idSchedule: response.data[i].idSchedule,
              pnpLink: response.data[i].PnPLink,
              idSite: response.data[i].idSite,
              BypassThreshold: response.data[i].BypassThreshold,
              data: [],
              savingsData: []
            });
          }
          self.meterAccountList = tmp;
          self.status = "Meter accounts were loaded.";
          callback(false);
        })
        .catch(function(error) {
          console.log("Error Getting getMeterAccounts  data");
          location.reload(true);
          self.status = "Error loading meter accounts.";
          console.log(error);
          callback(true);
        });
    },
    getOverviewParameters(idPLC, callback) {
      let self = this;
      let start = moment();
      axios
        .get(self.backendUrl + "/getOverviewParameters", {
          params: { idPLC: idPLC }
        })
        .then(function(response) {
          callback(false, response.data);
        })
        .catch(function(error) {
          console.log("Error Getting getOverviewParameters data");
          console.log(error);
          callback(true, null);
        });
    },

    getConsumptionID(callback) {
      let self = this;
      let start = moment();
      self.status = "Loading consumption data ...";
      axios
        .get(self.backendUrl + "/getConsumptionID", {
          params: {
            idMeterAccount: 228,
            startDate: self.todaysMinus30Date,
            endDate: self.todaysDate
          }
        })
        .then(function(response) {
          self.rawConsumptionData = response.data;
          self.status = "Loaded consumption data.";
          callback(false);
        })
        .catch(function(error) {
          console.log("Error Getting getConsumptionID data");
          console.log(error);
          self.status = "Error loading consumption data.";
          location.reload(true);
          callback(true);
        });
    },

    getProcessedConsumption(callback) {
      console.log("Getting proccess data ...");
      let self = this;
      self.processedConsumptionAvailable = false;
      let start = moment();
      self.status = "Loading processed consumption data ...";
      let last6months = moment()
        .subtract(120, "days")
        .format("YYYY-MM-DD");
      axios
        .get(self.backendUrl + "/getProssedConsumption", {
          params: {
            startDate: last6months,
            endDate: self.todaysDate
          }
        })
        .then(function(response) {
          self.processedConsumptionData = response.data;
          if (self.processedConsumptionData.length > 0) {
            self.processedComsumptionLoaded = true;
            callback(false);
          } else callback(true);
        })
        .catch(function(error) {
          console.log("Error Getting getConsumptionID data");
          console.log(error);
          self.status = "Error loading consumption data.";
          location.reload(true);
          callback(true);
        });
    },

    setupProcessedConsumptionGraphOptions() {
      this.processedGraphOptions = {
        chart: {
          stacked: false,
          id: "vuechart-pc",
          //  group: 'BacktestCharts',  // uncomment to sync graphs
          animations: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: [
          "#00456b",
          "#578e67",
          "#d9815b",
          "#3455cd",
          "#4a4a4a",
          "#3455cd",
          "#5cd8f1",
          "#8f1789",
          "#c35989",
          "#78945d"
        ],
        /*colors: [
          function({ value, seriesIndex, w }) {
            if (value < 55) {
              return "#7E36AF";
            } else {
              return "#D9534F";
            }
          },
          function({ value, seriesIndex, w }) {
            if (value < 100) {
              return "#7E36AF";
            } else {
              return "#D9534F";
            }
          }
        ],*/
        /* stroke: {
              width: [0, 4]
            },*/
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true
        },
        xaxis: {
          type: "datetime",
          labels: {
            show: true,
            formatter: function(value, timestamp, index) {
              return moment(new Date(timestamp)).format("YYYY-MM-DD");
            }
          }
        }
        /*yaxis: {
          max: 100
        }*/
      };

      this.processedStackGraphOptions = {
        chart: {
          stacked: true,
          id: "vuechart-pcstacked",
          //  group: 'BacktestCharts',  // uncomment to sync graphs
          animations: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: [
          "#00456b",
          "#578e67",
          "#d9815b",
          "#3455cd",
          "#4a4a4a",
          "#3455cd",
          "#5cd8f1",
          "#8f1789",
          "#c35989",
          "#78945d"
        ],
        /*colors: [
          function({ value, seriesIndex, w }) {
            if (value < 55) {
              return "#7E36AF";
            } else {
              return "#D9534F";
            }
          },
          function({ value, seriesIndex, w }) {
            if (value < 100) {
              return "#7E36AF";
            } else {
              return "#D9534F";
            }
          }
        ],*/
        /* stroke: {
              width: [0, 4]
            },*/
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true
        },
        xaxis: {
          type: "datetime",
          labels: {
            show: true,
            formatter: function(value, timestamp, index) {
              return moment(new Date(timestamp)).format("YYYY-MM-DD");
            }
          }
        }
        /*yaxis: {
          max: 100
        }*/
      };
    },

    setupSavingGraphOptions() {
      this.savingGraphOptions = {
        chart: {
          stacked: false,
          id: "vuechart-savings",
          //  group: 'BacktestCharts',  // uncomment to sync graphs
          animations: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "top"
            }
          }
        },
        dataLabels: {
          enabled: true
        },
        title: {
          text: "Savings when under VSD control",
          align: "left"
        },
        colors: [
          "#00456b",
          "#578e67",
          "#d9815b",
          "#3455cd",
          "#4a4a4a",
          "#3455cd",
          "#5cd8f1",
          "#8f1789",
          "#c35989",
          "#78945d"
        ],
        /*colors: [
          function({ value, seriesIndex, w }) {
            if (value < 55) {
              return "#7E36AF";
            } else {
              return "#D9534F";
            }
          },
          function({ value, seriesIndex, w }) {
            if (value < 100) {
              return "#7E36AF";
            } else {
              return "#D9534F";
            }
          }
        ],*/
        /* stroke: {
              width: [0, 4]
            },*/
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true
        },
        xaxis: {
          type: "datetime",
          labels: {
            show: true,
            formatter: function(value, timestamp, index) {
              return moment(new Date(timestamp)).format("YYYY-MM-DD");
            }
          }
        },
        yaxis: {
          max: 100,
          min: 0,
          labels: {
            show: true
          }
        }
      };
    },

    getSavingMeterAccount(idMeterAccount, callback) {
      let self = this;
      let start = moment();
      console.log("Callign meter account with : " + idMeterAccount);
      self.savingsAvailable = false;

      axios
        .get(self.backendUrl + "/getSavingMeterAccount", {
          params: {
            idMeterAccount: idMeterAccount,
            startDate: self.todaysDate
          }
        })
        .then(function(response) {
          self.activeSavings = response.data;
          try {
            self.activeSavings.last7days[0].kwSavingsPercentage =
              Math.round(
                self.activeSavings.last7days[0]["ImportkWh"] /
                  self.activeSavings.last7days[0]["PreEDSRunningkWh"] *
                  100 *
                  100
              ) / 100;
            self.activeSavings.last12months[0].kwSavingsPercentage =
              Math.round(
                self.activeSavings.last12months[0]["ImportkWh"] /
                  self.activeSavings.last12months[0]["PreEDSRunningkWh"] *
                  100 *
                  100
              ) / 100;
            if (self.activeSavings.last7days[0].kwSavingsPercentage < 0)
              self.activeSavings.last7days[0].kwSavingsPercentage = "N/A";
            if (self.activeSavings.last12months[0].kwSavingsPercentage < 0)
              self.activeSavings.last12months[0].kwSavingsPercentage = "N/A";
            self.savingsAvailable = true;
          } catch (err) {
            console.log("Caught error in activeSavings");
            console.log(err);
            self.savingsAvailable = false;
          }
          callback(false);
        })
        .catch(function(error) {
          console.log("Error Getting getSavingMeterAccount data");
          console.log(error);
          self.savingsAvailable = false;
          callback(true);
        });
    },
    getSavingMeterAccountPercentage(idMeterAccount, callback) {
      let self = this;
      let start = moment();
      console.log("Callign meter account with : " + idMeterAccount);
      self.savingsAvailable = false;

      axios
        .get(self.backendUrl + "/getSavingMeterAccountPercentage", {
          params: {
            idMeterAccount: idMeterAccount,
            startDate: self.todaysDate
          }
        })
        .then(function(response) {
          console.log("Got percentage Data");
          console.log(response);
          let tmpData = null;
          tmpData = [];
          let dateForPlot = moment(self.todaysDate);

          for (let i = 0; i < response.data.recordsets.length; i++) {
            let newTime = parseInt(dateForPlot.format("x"));
            tmpData.push([
              newTime,
              Math.round(response.data.recordsets[i][0].saving)
            ]);
            dateForPlot.subtract(7, "days");
          }
          console.log("Data for plot");
          console.log(tmpData);
          self.savingsgraphData = [
            {
              name: "savings",
              type: "column",

              data: tmpData
            }
          ];
          callback(false);
        })
        .catch(function(error) {
          console.log("Error Getting getSavingMeterAccount data");
          console.log(error);
          self.savingsAvailable = false;
          callback(true);
        });
    },

    getAllTickets(callback) {
      let self = this;
      let start = moment();

      axios
        .get(self.backendUrl + "/getTickets", {
          params: { startDate: self.todaysMinus30Date }
        })
        .then(function(response) {
          self.allTickets = response.data;
          callback(false);
        })
        .catch(function(error) {
          console.log("Error Getting getAllTickets data");
          console.log(error);
          callback(true);
        });
    },
    getAllTags(callback) {
      let self = this;

      axios
        .get(self.backendUrl + "/getTags")
        .then(function(response) {
          self.allTags = response.data;
          callback(false);
        })
        .catch(function(error) {
          console.log("Error Getting  getAllTags data");
          console.log(error);
          callback(true);
        });
    },
    getTagType(callback) {
      let self = this;

      axios
        .get(self.backendUrl + "/getTagType")
        .then(function(response) {
          self.tagType = response.data;
          callback(false);
        })
        .catch(function(error) {
          console.log("Error Getting  getAllTags data");
          console.log(error);
          callback(true);
        });
    },
    getTagCategories(callback) {
      let self = this;

      axios
        .get(self.backendUrl + "/getTagCategory")
        .then(function(response) {
          self.tagCategories = response.data;
          callback(false);
        })
        .catch(function(error) {
          console.log("Error Getting  getAllTags data");
          console.log(error);
          callback(true);
        });
    },

    openPnp() {
      let self = this;
      window.open(self.meterAccountList[self.currentIndex].pnpLink);
    },
    openTicket() {
      let self = this;
      window.open("https://energydrive.dnsalias.com/ticketcop/createTicket");
    },

    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  },

  created: function() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    var self = this;
    self.todaysDate = moment().format("YYYY-MM-DD");
    self.todaysMinus30Date = moment()
      .subtract(30, "days")
      .format("YYYY-MM-DD");

    /* TEST CODE */
    //self.createJunkData(130);

    // add event listners and handlers for keyboard shortcuts
    self.addKeyboardEvents();
    self.setupProcessedConsumptionGraphOptions();
    self.setupSavingGraphOptions();
    self.getAllTickets(function(err) {});
    self.getAllTags(function(err) {
      console.log("Got all the tags");
    });
    self.getTagType(function(err) {});
    self.getTagCategories(function(err) {});
    self.getMeterAccounts(function(err1) {
      self.getConsumptionID(function(err) {
        if (err1 || err) {
          console.log(err1);
          console.log(err);
        } else {
          self.status = "";
          self.dataLoaded = true;

          self.updateGraph(3);
          self.renderPCGraph();
          console.log("Got al data needed from server");
        }
      });
    });

    CYCLE_TIMER = setInterval(function() {
      if (self.streampaused) {
        self.updateGraph(1);
        self.renderPCGraph();
      }
    }, 7000);
    self.getProcessedConsumption(function(err) {});
    setInterval(function() {
      //console.log(self.timeElapse);
      self.timeElapsed = self.timeElapsed + 1;
    }, 1000);
  },
  computed: {
    meterAccountTags: function() {
      let self = this;
      let data = [];
      if (self.dataLoaded) {
        data = self.allTags.filter(function(item) {
          try {
            if (
              item.MeterAccount ==
              self.meterAccountList[self.currentIndex].idMeterAccount
            ) {
              return true;
            } else {
              return false;
            }
          } catch (err) {
            return false;
          }
        });
      }
      return data;
    },
    listTags: function() {
      let self = this;
      let data = [];
      if (self.dataLoaded) {
        data = self.tagType.filter(function(item) {
          try {
            if (item.TagCategory == self.selectedTagCategory) {
              return true;
            } else {
              return false;
            }
          } catch (err) {
            return false;
          }
        });
      }
      return data;
    },
    meterAccountTickets: function() {
      let self = this;
      let data = [];
      if (self.dataLoaded) {
        data = self.allTickets.filter(function(item) {
          try {
            if (
              item.idSite == self.meterAccountList[self.currentIndex].idSite
            ) {
              if (item.isSite == false) {
                if (
                  item.idMeterAccount !=
                  self.meterAccountList[self.currentIndex].idMeterAccount
                ) {
                  return false; // return false if it is not a site ticket and the idmeterAccount is not applicable to this meteraccount
                }
              }

              if (item.isSite) {
                if (item.Resolved) {
                  item.TagPrefix = "ST [R] ";
                } else {
                }
              } else {
                if (item.Resolved) {
                  item.TagPrefix = "[R] ";
                } else {
                  item.TagPrefix = "";
                }
              }
              if (item.TicketCategory == 1) {
                if (item.Resolved) {
                  item.variant = "primary";
                } else item.variant = "warning";
                item.TicketIssued = moment(item.TicketIssued).format(
                  "YYYY-MM-DD hh:mm"
                );
                return true;
              }
              if (item.TicketCategory == 8 && item.TicketSubCategory == 48) {
                if (item.Resolved) {
                  item.variant = "success";
                } else item.variant = "danger";
                item.TicketIssued = moment(item.TicketIssued).format(
                  "YYYY-MM-DD hh:mm"
                );

                return true;
              }
              return false;
            } else {
              return false;
            }
          } catch (err) {
            return false;
          }
        });

        self.options2.annotations.xaxis = [];
        for (let i = 0; i < data.length; i++) {
          if (data[i].TicketCategory == 1) {
            self.options2.annotations.xaxis.push({
              x: moment(data[i].TicketIssued).format("x"),
              borderColor: "#fc0303",
              label: {
                borderColor: "#000000",
                style: {
                  color: "#fff",
                  background: "#dc3545",
                  opacity: 0.5,
                  fontSize: "16px"
                },
                text: "#" + data[i].idTicket
              }
            });
          } else {
            self.options2.annotations.xaxis.push({
              x: moment(data[i].TicketIssued).format("x"),
              borderColor: "#fc0303",
              label: {
                borderColor: "#000000",
                style: {
                  color: "#fff",
                  background: "#007bff",
                  opacity: 0.5,
                  fontSize: "16px"
                },
                text: "#" + data[i].idTicket
              }
            });
          }
        }
      }

      return data;
    }
  },
  mounted: function() {},
  destroyed: function() {
    // must delete dygraph instance to free up memory
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style>
.tooltip {
  display: block !important;

  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  font-size: 18px;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
</style>
